<template>
    <div class="gim-menu-item" @click.meta.capture.stop="click" @click.ctrl.capture.stop="click">
    <el-menu-item :index="index" >
        <span :class="menuClass" slot="title">{{title}}</span>
    </el-menu-item>
    </div>
    
</template>

<script>
export default {
	props:{
		title:{
			type:String,
		},
		index:{
			type:String,
			required:true,
		},
		menuClass:{
			type:String,
		}
	},
	methods:{
		click(){
			window.open(this.index);
		}
	}
}
</script>

